import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { recordUiEvent } from "./lib/logRingBuffer";
import { installChunkReloadHandler } from "./lib/chunkReload.js";
import { installRouteCapture } from "./services/routeCapture.js";
import { startTelemetry } from "./services/telemetry.js";
import { captureTelemetryEntry } from "./services/p2Telemetry.js";

// Recover from stale lazy-import chunks after a deploy: a tab that loaded the
// previous build references old hashed chunk names, so the first code-split import
// after a redeploy 404s ("Failed to fetch dynamically imported module"). Reload once
// to pull the fresh index + current hashes. Loop-guarded (see chunkReload.js).
installChunkReloadHandler(window);

// Capture browser-level events into the ring buffer so bug reports include
// the last N events of UI activity. The buffer is a singleton; this code
// just wires up listeners. Each event is timestamped at push time.

captureTelemetryEntry();

installRouteCapture();

window.addEventListener("error", (e) => {
  recordUiEvent({
    event: "ui.error",
    message: e.message,
    source: e.filename,
    line: e.lineno,
    col: e.colno,
  });
});

window.addEventListener("unhandledrejection", (e) => {
  recordUiEvent({
    event: "ui.unhandled_rejection",
    reason: String(e.reason && e.reason.message ? e.reason.message : e.reason),
  });
});

// Before React renders: the service buffers until /api/me says whether this
// deployment streams (hooks/useAuthSession.ts), then replays anything unsent.
startTelemetry();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
